export default __webpack_public_path__ + "static/media/logo_gamanza.a89963b7.png";